import React, { useState } from 'react';
import s from './Profile.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserSubscription, selectUser } from '../../../../store/selectors/authSelectors';
import { deauthorizeProvider } from '../../../../shared/api/authApi';
import { AppDispatch } from '../../../../store/store';
import IconProfileInstagram from '../../../../shared/ui/icons/IconProfileInstagram';
import IconProfileLinkedin from '../../../../shared/ui/icons/IconProfileLinkedin';
import IconProfileTwitter from '../../../../shared/ui/icons/IconProfileTwitter';
import IconProfileTiktok from '../../../../shared/ui/icons/IconProfileTiktok';
import IconProfileYoutube from '../../../../shared/ui/icons/IconProfileYoutube';
import IconProfilePinterest from '../../../../shared/ui/icons/IconProfilePinterest';
import IconProfileFacebook from '../../../../shared/ui/icons/IconProfileFacebook';
import IconProfileThreads from '../../../../shared/ui/icons/IconProfileThreads';
import DisconnectModal from './DisconnectModal';
import ConnectModal from './ConnectModal';
import { toast } from 'react-toastify';
import { setUser } from '../../../../store/slices/authSlice';
import { setPricingModal } from '../../../../store/slices/pageSlice';
import IconLock from '../../../../shared/ui/icons/IconLock';
import PricingModal from '../../../../shared/ui/pricing-modal/PricingModal';
import {
    selectIsBasicSubscription,
    selectIsFreeSubscription,
    selectIsPremiumSubscription,
    selectIsProSubscription,
} from '../../../../store/selectors/subscriptionSelector';
import { fetchCurrentUser } from '../../../../shared/api/authApi';

const ConnectedSocialAccount = () => {
    const user = useSelector(selectUser);
    const dispatch = useDispatch<AppDispatch>();
    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);
    const isProSubscription = useSelector(selectIsProSubscription);
    const isPremiumSubscription = useSelector(selectIsPremiumSubscription);
    const userSubscription = useSelector(selectUserSubscription);

    console.log('isPremiumSubscription', isPremiumSubscription);
    console.log('isProSubscription', isProSubscription);
    console.log('isBasicSubscription', isBasicSubscription);
    console.log('isFreeSubscription', isFreeSubscription);

    const socialConnections = user?.social_connections
        ? typeof user.social_connections === 'string'
            ? JSON.parse(user.social_connections)
            : user.social_connections
        : {
              facebook: null,
              instagram: null,
              linkedin: null,
              pinterest: null,
              threads: null,
              tiktok: null,
              twitter: null,
              youtube: null,
          };

    const [disconnectModal, setDisconnectModal] = useState<{ isOpen: boolean; provider: string }>({
        isOpen: false,
        provider: '',
    });
    const [isLoadingDisconnect, setIsLoadingDisconnect] = useState(false);
    const [isLoadingConnect, setIsLoadingConnect] = useState(false);
    const [connectModal, setConnectModal] = useState<{ isOpen: boolean; provider: string }>({
        isOpen: false,
        provider: '',
    });

    const handleDisconnectClick = (provider: string) => {
        setDisconnectModal({ isOpen: true, provider });
    };

    const handleDisconnectConfirm = async () => {
        try {
            if (!user) {
                return;
            }
            setIsLoadingDisconnect(true);
            await dispatch(deauthorizeProvider(disconnectModal.provider)).unwrap();
            // const updatedConnections = {
            //     ...user.social_connections,
            //     [disconnectModal.provider]: null,
            // };

            await dispatch(fetchCurrentUser());

            //dispatch(setUser({ ...user, social_connections: updatedConnections }));

            setDisconnectModal({ isOpen: false, provider: '' });
            setIsLoadingDisconnect(false);
            toast.success('Provider disconnected successfully');
        } catch (error) {
            console.error('Failed to disconnect provider:', error);
        }
    };

    const handleDisconnectCancel = () => {
        setDisconnectModal({ isOpen: false, provider: '' });
    };

    const handleConnectConfirm = async () => {
        try {
            setIsLoadingConnect(true);
            const token = localStorage.getItem('authToken');
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
            const redirectUri = window.location.origin + '/settings';

            const authUrl = `${apiUrl}/auth/${connectModal.provider}?user_token=${token}&link_account=true&redirect_uri=${encodeURIComponent(redirectUri)}`;

            window.location.href = authUrl;
        } catch (error) {
            console.error('Failed to connect provider:', error);
            setIsLoadingConnect(false);
            toast.error('Failed to connect provider');
        }
    };

    const handleConnectCancel = () => {
        setConnectModal({ isOpen: false, provider: '' });
    };

    const connectedCount = Object.values(socialConnections).filter(Boolean).length;

    const getConnectionLimit = () => {
        if (isFreeSubscription || isBasicSubscription) return 1;
        if (isProSubscription || isPremiumSubscription) return 3;
        return 0;
    };

    const connectionLimit = getConnectionLimit();
    const canConnectMore = connectedCount < connectionLimit;

    const handleConnectClick = (provider: string) => {
        if (canConnectMore) {
            setConnectModal({ isOpen: true, provider });
        } else {
            dispatch(setPricingModal(true));
        }
    };

    return (
        <>
            <h3 className={s.sectionTitle}>Connected social account</h3>

            <div className={s.socialGrid}>
                <button
                    className={`${s.socialButton} ${socialConnections.instagram ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.instagram
                            ? handleDisconnectClick('instagram')
                            : handleConnectClick('instagram')
                    }
                >
                    <IconProfileInstagram />
                    <span className={s.socialName}>
                        {socialConnections?.instagram ?? 'Instagram'}
                    </span>
                    {socialConnections.instagram ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.youtube ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.youtube
                            ? handleDisconnectClick('youtube')
                            : handleConnectClick('youtube')
                    }
                >
                    <IconProfileYoutube />
                    <span className={s.socialName}>{socialConnections?.youtube ?? 'YouTube'}</span>
                    {socialConnections.youtube ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.linkedin ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.linkedin
                            ? handleDisconnectClick('linkedin')
                            : handleConnectClick('linkedin')
                    }
                >
                    <IconProfileLinkedin />
                    <span className={s.socialName}>
                        {socialConnections?.linkedin ?? 'LinkedIn'}
                    </span>
                    {socialConnections.linkedin ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.pinterest ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.pinterest
                            ? handleDisconnectClick('pinterest')
                            : handleConnectClick('pinterest')
                    }
                >
                    <IconProfilePinterest />
                    <span className={s.socialName}>
                        {socialConnections?.pinterest ?? 'Pinterest'}
                    </span>
                    {socialConnections.pinterest ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.twitter ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.twitter
                            ? handleDisconnectClick('twitter')
                            : handleConnectClick('twitter')
                    }
                >
                    <IconProfileTwitter />
                    <span className={s.socialName}>{socialConnections?.twitter ?? 'Twitter'}</span>
                    {socialConnections.twitter ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.facebook ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.facebook
                            ? handleDisconnectClick('facebook')
                            : handleConnectClick('facebook')
                    }
                >
                    <IconProfileFacebook />
                    <span className={s.socialName}>
                        {socialConnections?.facebook ?? 'Facebook'}
                    </span>
                    {socialConnections.facebook ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.tiktok ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.tiktok
                            ? handleDisconnectClick('tiktok')
                            : handleConnectClick('tiktok')
                    }
                >
                    <IconProfileTiktok />
                    <span className={s.socialName}>{socialConnections?.tiktok ?? 'TikTok'}</span>
                    {socialConnections.tiktok ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>

                <button
                    className={`${s.socialButton} ${socialConnections.threads ? s.connected : ''}`}
                    onClick={() =>
                        socialConnections.threads
                            ? handleDisconnectClick('threads')
                            : handleConnectClick('threads')
                    }
                >
                    <IconProfileThreads />
                    <span className={s.socialName}>{socialConnections?.threads ?? 'Threads'}</span>
                    {socialConnections.threads ? (
                        <span className={s.connectedText}>Connected</span>
                    ) : !canConnectMore ? (
                        <IconLock color="#c9cdd5" />
                    ) : null}
                </button>
            </div>

            <DisconnectModal
                isOpen={disconnectModal.isOpen}
                onClose={handleDisconnectCancel}
                onConfirm={handleDisconnectConfirm}
                provider={disconnectModal.provider}
                isLoading={isLoadingDisconnect}
            />

            <ConnectModal
                isOpen={connectModal.isOpen}
                onClose={handleConnectCancel}
                onConfirm={handleConnectConfirm}
                provider={connectModal.provider}
                isLoading={isLoadingConnect}
            />

            <PricingModal />
        </>
    );
};

export default ConnectedSocialAccount;
